import { AnalyticsUtils } from '@analytics/utils';
import { inject, Injectable } from '@angular/core';
import type {
  HomeBatteryFunnelSettingsInterface,
  HomeBatteryFunnelStep,
} from '@innogy/feh/models';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { createFunnelEffectCreators } from '@innogy/feh/shared';
import type { GenericProductData } from '@legacy/common-ui-models';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-angular';

import { selectHomeBatteryFunnelSettings } from '../selectors/homebattery-funnel.selectors';
import {
  initializeHomeBatteryFunnelStepAction,
  handleHomeBatteryFunnelPrivateErrorAction,
  onHomeBatteryFunnelNavigationAction,
  setHomeBatteryFunnelInitializedAction,
  handleHomeBatteryFunnelGenericErrorAction,
  mintHomeBatteryTrackingIdAction,
} from '../actions';
import { of } from 'rxjs';

@Injectable()
export class HomeBatteryFunnelEffects {
  private readonly actions$ = inject(Actions);
  private readonly store$ = inject(Store);
  private readonly analyticsUtils = inject(AnalyticsUtils);

  private readonly funnelSettings$ = this.store$.select(
    selectHomeBatteryFunnelSettings
  );
  private readonly isXpEditorActive$ = isEditorActive();

  private readonly effects = createFunnelEffectCreators<
    HomeBatteryFunnelStep,
    HomeBatteryFunnelSettingsInterface,
    GenericProductData
  >(
    this.actions$,
    this.funnelSettings$,
    of(this.isXpEditorActive$),
    'startPage',
    'wizard',
    this.analyticsUtils,
    {
      initializeFunnelStepAction: initializeHomeBatteryFunnelStepAction,
      handleFunnelPrivateErrorAction: handleHomeBatteryFunnelPrivateErrorAction,
      onFunnelNavigationAction: onHomeBatteryFunnelNavigationAction,
      setFunnelInitializedAction: setHomeBatteryFunnelInitializedAction,
      handleFunnelGenericErrorAction: handleHomeBatteryFunnelGenericErrorAction,
      mintTrackingIdAction: mintHomeBatteryTrackingIdAction,
    }
  );

  public readonly onInitHomeBatteryFunnel$ =
    this.effects.initializeFunnelStepEffectCreator();

  public readonly onHomeBatteryFunnelNavigation$ =
    this.effects.onFunnelNavigationEffectCreator();

  public readonly onHomeBatteryFunnelPrivateError$ =
    this.effects.handleFunnelPrivateErrorEffectCreator();

  public readonly onHomeBatteryFunnelGenericError$ =
    this.effects.handleFunnelGenericErrorEffectCreator();

  public readonly mintHomeBatteryTrackingId$ =
    this.effects.mintTrackingIdEffectCreator();
}
